'use client';
import { Player, Controls } from '@lottiefiles/react-lottie-player';
import animation from './oxen-logo-animation.json';

export const SuspenseLoader: React.FC<{ children?: React.ReactNode }> = ({ children }) => (
  <div
    style={{
      minHeight: 200,
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      justifyContent: 'center',
    }}
  >
    <OxenLoader size="100px" />
    <p>{children || 'Loading...'}</p>
  </div>
);

const OxenLoader: React.FC<{ size: string }> = ({ size = '100px' }) => (
  // <div style={{ width: size, height: size, border: '1px solid green' }}>
  //   <Lottie animationData={animation} loop={true} />
  // </div>
  // <Player autoplay renderer="svg" loop src={animation} style={{ height: '300px', width: '300px' }}>
  //   {/* <Controls visible={true} buttons={['play', 'repeat', 'frame', 'debug']} /> */}
  // </Player>
  // eslint-disable-next-line @next/next/no-img-element
  <img src="/assets/images/oxen_loader_200px.gif" alt="Loading..." width={size} height={size} />
);

export default OxenLoader;
